var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 4.75C6.87665 4.75 4.75 6.87665 4.75 9.5V22.5C4.75 25.1234 6.87665 27.25 9.5 27.25H22.5C25.1234 27.25 27.25 25.1234 27.25 22.5V9.5C27.25 6.87665 25.1234 4.75 22.5 4.75H9.5ZM6.25 9.5C6.25 7.70507 7.70507 6.25 9.5 6.25H22.5C24.2949 6.25 25.75 7.70507 25.75 9.5V12.25H21C18.9289 12.25 17.25 13.9289 17.25 16C17.25 18.0711 18.9289 19.75 21 19.75H25.75V22.5C25.75 24.2949 24.2949 25.75 22.5 25.75H9.5C7.70507 25.75 6.25 24.2949 6.25 22.5V9.5ZM25.75 13.75H21C19.7574 13.75 18.75 14.7574 18.75 16C18.75 17.2426 19.7574 18.25 21 18.25H25.75V13.75ZM14 12H10V10.5H14V12ZM21 17C21.5523 17 22 16.5523 22 16C22 15.4477 21.5523 15 21 15C20.4477 15 20 15.4477 20 16C20 16.5523 20.4477 17 21 17Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.6df1fa3d530e5afb7396974c4ca1be9d.svg";
export { ForwardRef as ReactComponent };